var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M27,19.2l-1.7-2.5L23,14l-0.5-0.5L22,14l-2.3,2.7L18,19.2c-0.8,1.4-1.3,2.9-1.7,4.4c-0.2,0.6-0.2,1.2-0.2,1.8 c0,0.6,0.1,1.1,0.2,1.7c0.3,1,0.9,1.8,1.6,2.5c2.7,2.3,6.5,2.3,9.2,0c0.7-0.7,1.3-1.5,1.6-2.5c0.1-0.6,0.2-1.1,0.2-1.7 c0-0.6,0-1.2-0.2-1.8C28.3,22.1,27.8,20.6,27,19.2z M28.1,26.9c-0.2,0.9-0.7,1.7-1.3,2.3c-2.5,2-6.1,2-8.6,0 c-0.6-0.6-1.1-1.4-1.3-2.3c-0.2-0.5-0.3-1-0.3-1.5c0-0.6,0.1-1.1,0.2-1.7c0.3-1.5,0.9-2.9,1.7-4.2c0.5-0.8,1.1-1.6,1.7-2.4 c0.7-1,1.4-1.9,2.2-2.7h0.2c0.8,0.9,1.6,1.8,2.3,2.7l1.6,2.4c0.8,1.3,1.4,2.7,1.7,4.2c0.1,0.6,0.2,1.1,0.2,1.7 C28.4,25.9,28.3,26.4,28.1,26.9z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M22.5,9C15,9,9,15,9,22.5S15,36,22.5,36S36,30,36,22.5C35.9,15.1,29.9,9.1,22.5,9z M29.2,27.2 c-0.3,1.1-0.9,2-1.7,2.8c-2.9,2.4-7.1,2.4-10,0c-0.8-0.8-1.4-1.7-1.7-2.8c-0.1-0.6-0.2-1.1-0.2-1.7c-0.1-0.7,0-1.3,0.1-2 c0.4-1.6,1.1-3.1,1.9-4.5c0.5-0.9,1.1-1.8,1.7-2.6l2.3-2.8l0.9-0.9l0.9,0.9l2.3,2.8c0.6,0.8,1.2,1.7,1.7,2.6 c0.8,1.4,1.5,2.9,1.9,4.5c0.1,0.7,0.2,1.3,0.1,2C29.4,26.1,29.3,26.6,29.2,27.2z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M22.5,7.5c-8.3,0-15,6.7-15,15c0.1,8.3,6.7,14.9,15,15c8.3-0.1,14.9-6.7,15-15C37.4,14.2,30.8,7.6,22.5,7.5z  M22.5,36C15,36,9,30,9,22.5S15,9,22.5,9S36,15,36,22.5C35.9,29.9,29.9,35.9,22.5,36z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#4AB8DC",
  d: "M27.4,19c-0.5-0.9-1.1-1.8-1.7-2.6l-2.3-2.8l-0.9-0.9l-0.9,0.9l-2.3,2.8c-0.6,0.8-1.2,1.7-1.7,2.6 c-0.8,1.4-1.5,2.9-1.9,4.5c-0.1,0.7-0.2,1.3-0.1,2c0,0.6,0.1,1.1,0.2,1.7c0.3,1.1,0.9,2,1.7,2.8c2.9,2.4,7.1,2.4,10,0 c0.8-0.8,1.4-1.7,1.7-2.8c0.1-0.6,0.2-1.1,0.2-1.7c0.1-0.7,0-1.3-0.1-2C28.9,21.9,28.2,20.4,27.4,19z M28.7,27.1 c-0.3,1-0.9,1.8-1.6,2.5c-2.7,2.3-6.5,2.3-9.2,0c-0.7-0.7-1.3-1.5-1.6-2.5c-0.1-0.6-0.2-1.1-0.2-1.7c0-0.6,0-1.2,0.2-1.8 c0.4-1.5,0.9-3,1.7-4.4l1.7-2.5L22,14l0.5-0.5L23,14l2.3,2.7l1.7,2.5c0.8,1.4,1.3,2.9,1.7,4.4c0.2,0.6,0.2,1.2,0.2,1.8 C28.9,26,28.8,26.5,28.7,27.1z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#4AB8DC",
  d: "M26.5,19.5l-1.6-2.4c-0.7-0.9-1.5-1.8-2.3-2.7h-0.2c-0.8,0.8-1.5,1.7-2.2,2.7c-0.6,0.8-1.2,1.6-1.7,2.4 c-0.8,1.3-1.4,2.7-1.7,4.2c-0.1,0.6-0.2,1.1-0.2,1.7c0,0.5,0.1,1,0.3,1.5c0.2,0.9,0.7,1.7,1.3,2.3c2.5,2,6.1,2,8.6,0 c0.6-0.6,1.1-1.4,1.3-2.3c0.2-0.5,0.3-1,0.3-1.5c0-0.6-0.1-1.1-0.2-1.7C27.9,22.2,27.3,20.8,26.5,19.5z"
});

function SvgHumidity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.4ea1a0ee79146177e07f6ad8baeb3641.svg";
export { ForwardRef as ReactComponent };